<template>

  <div class="nav-flex">
    <Counter />
    <div class="stack">
      <button class="reset-button" @click="$bus.emit('app:reset', selectedText.length)">Reset level</button>
      <button class="reset-button" @click="$bus.emit('app:reset-game', selectedText.length)">Reset game</button>
    </div>
  </div>

  <div v-if="showOutput" class="output">
  	<span v-for="char, id in selectedText" :key="id" :class="{ active: activeIndex == id, correct: correctCharIds.includes(id) }">{{ char }}</span>
  </div>

</template>

<script>
import texts from '@/data/texts.json'
import { nextTick } from 'vue'
import Counter from '@/components/Counter'

export default {

  name: 'Output',

  components: {
    Counter,
  },

  data() {

    return {
    	texts: texts,
    	selected: 0,
    	activeIndex: 0,
      correctCharIds: [],
      showOutput: true,
    }
  },

  computed: {

  	selectedText() {

  		return this.texts[this.selected]
  			.join(' ')
  			.split('')
  	},
  	currentChar() {
  		return this.selectedText[this.activeIndex]
  	},
  },

  methods: {
  	handleIncrement(char) {
  		if (this.currentChar == char) {
  			this.$bus.emit('app:correct', {
          index: this.activeIndex,
          char: char
        })
  		}
  		this.activeIndex++
  		this.$bus.emit('app:next-char', this.currentChar)
  	},
  	handleReset() {
  		this.activeIndex = 0
      this.correctCharIds = []
  		this.$bus.emit('app:next-char', this.currentChar)
  	},
    handleFinished() {
      this.$bus.emit('app:correct-results', this.correctChars)
    },
    handleCorrectResults(correctChars) {
      this.showOutput = false
      nextTick().then( () => {
        this.correctCharIds = correctChars.map( (char) => char.index )
        this.showOutput = true
      })
    },
    handleGameStarted(selectedLevel) {
      this.selected = selectedLevel
  		this.$bus.emit('app:reset', this.selectedText.length)
    },
  },

  mounted() {
  	nextTick().then(() => {
    	this.$bus.on('app:increment', this.handleIncrement)
    	this.$bus.on('app:reset', this.handleReset)
      this.$bus.on('app:game-started', this.handleGameStarted)
      this.$bus.on('app:correct-results', this.handleCorrectResults)
	  	this.$bus.emit('app:reset', this.selectedText.length)
	  	this.$bus.emit('app:next-char', this.currentChar)
	  })
  },
}
</script>

<style lang="css" scoped>
.output {
 	text-align: center;
 	padding: 20px;
 	font-size: 37px;
}
.output span.active {
	color: red;
	text-decoration: underline;
}
.output span.correct {
  color: green;
}
.reset-button {
  cursor: pointer;
  font-size: 17px;
  padding: 2px 20px; /* Optional: Adjust the padding */
  text-align: center; /* Optional: Center the text inside the button */
  margin-top: 0px; /* Add some space between the select box and the button */
  /* Add other styles for your button here */
}
.nav-flex {
  padding: 10px;
  display: flex;
  flex-direction: row; /* Stack items vertically */
  justify-content: space-between; /* Center vertically */
  align-items: center; /* Center horizontally */
}
.stack {
  display: flex;
  flex-direction: column;
}
.stack * {
  margin-bottom: 10px;
}
</style>